class DetailsDrawer extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.content = this.details.querySelector('.mega-menu__content');
    this.closeTimeout = null;
    
    // Add hover event listeners
    this.addEventListener('mouseenter', this.open.bind(this));
    this.addEventListener('mouseleave', this.close.bind(this));
    
    // Prevent closing when hovering over the content
    this.content.addEventListener('mouseenter', this.preventClose.bind(this));
    this.content.addEventListener('mouseleave', this.close.bind(this));
  }

  open() {
    // Clear any existing timeout
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    // Set a timeout before closing
    this.closeTimeout = setTimeout(() => {
      this.details.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', false);
    }, 200); // 300ms delay
  }

  preventClose(event) {
    // Clear the timeout when hovering over content
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    event.stopPropagation();
  }
}

customElements.define('details-drawer', DetailsDrawer); 